import React from "react";
import { styled, Grid as GridBase, Button as ButtonBase, Card, Typography, Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

export const DeleteIconStyled = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const EditIconStyled = styled(EditIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const GridContainer = styled((props) => (
  <GridBase
    {...props}
    container
    justifyContent={props.justifyContent || "flex-start"}
    alignItems={props.alignItems || "center"}
  />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    align-items: center;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const WalletCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  boxShadow: "0 2px 4px rgba(50, 43, 71, 0.08)",
}));

export const WalletHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 12,
});

const walletTypeColor = (theme, type) => {
  switch (type) {
    case "deposit":
      return theme.palette.success.main;
    case "withdrawal":
      return theme.palette.warning.main;
    case "treasury":
      return theme.palette.info.main;
    default:
      return theme.palette.grey[500];
  }
};

export const WalletType = styled(Box)(({ theme, type }) => ({
  background: walletTypeColor(theme, type),
  color: theme.palette.common.white,
  padding: "4px 8px",
  borderRadius: theme.shape.borderRadius,
  fontSize: 12,
  fontWeight: 500,
}));

export const WalletAddress = styled(Box)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  background: theme.palette.grey[100],
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius / 3,
  margin: theme.spacing(1, 0),
  wordBreak: "break-all",
}));

export const WalletInfo = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  marginRight: 16,
  "& > div": {
    marginBottom: 4,
    "&:last-child": {
      marginBottom: 0,
    },
  },
});

export const InfoLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "0.875rem",
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),
}));

export const Button = styled(ButtonBase)(({ theme }) => ({
  "&.primary": {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
  "&.secondary": {
    background: theme.palette.grey[100],
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    "&:hover": {
      background: theme.palette.grey[200],
    },
  },
  "&.danger": {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      background: theme.palette.error.dark,
    },
  },
}));

export const FormContainer = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  padding: theme.spacing(2.5),
}));

export const FormTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(2.5),
  color: theme.palette.text.primary,
  fontSize: 18,
  fontWeight: 500,
}));

export const ListContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}));

export const ListTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
  fontSize: 18,
  fontWeight: 500,
}));

export const WalletItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1.5),
  background: theme.palette.background.paper,
  boxShadow: "0 1px 3px rgba(50, 43, 71, 0.08)",
}));

export const WalletActions = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(5),
  color: theme.palette.text.secondary,
  fontStyle: "italic",
}));
